import { setInitializedMap } from './setInitializedMap';
import { setRoutePoints } from './setRoutePoints';
import { resetRoutePoints } from './resetRoutePoints';
import { setShowStreetView } from './setShowStreetView';
import { updateSelectedPoint } from './updateSelectedPoint';
import { resetSelectedPoint } from './resetSelectedPoint';
import { updateFocusPoint } from './updateFocusPoint';
import { resetFocusPoint } from './resetFocusPoint';
import { resetPlannedRoutes } from './resetPlannedRoutes';
import { getPlannedRoutes } from './getPlannedRoutes';
import { getPlannerRoutesStations } from './getPlannerRoutesStations';
import { getPlannedRoutesPrices } from './getPlannedRoutesPrices';
import { updatePlannedRouteActiveCostType } from './updatePlannedRouteActiveCostType';
import { updatePlannedRouteActiveExcise } from './updatePlannedRouteActiveExcise';

export const mapOperations = {
  setInitializedMap,
  updateSelectedPoint,
  resetSelectedPoint,
  setRoutePoints,
  resetRoutePoints,
  setShowStreetView,
  updateFocusPoint,
  resetFocusPoint,
  resetPlannedRoutes,
  getPlannedRoutes,
  getPlannerRoutesStations,
  getPlannedRoutesPrices,
  updatePlannedRouteActiveCostType,
  updatePlannedRouteActiveExcise
};
